
import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { getDebtorsFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import { AccountsandFinanceurl, clientManagementUrl } from "../../../../config";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../../data/Axios/DynamicService";
import {
  allClientTypes,
  allIndividualClients,
  allCorporateClients,
} from "../../../../data/Axios/queries";

const base_url = AccountsandFinanceurl.uri;
const client_url = clientManagementUrl.uri;

const DebtorsForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const [clientTypes, setClientTypes] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🟢 Initial Values
  const initialValues = {
    clientTypeId: props.data ? props.data.clientTypeId : "",
    clientId: props.data ? props.data.clientId : "",
    debtorName: props.data ? props.data.debtorName : "",
    invoiceNumber: props.data ? props.data.invoiceNumber : "",
    invoiceDate: props.data ? props.data.invoiceDate : "",
    dueDate: props.data ? props.data.dueDate : "",
    amountBilled: props.data ? props.data.amountBilled : "",
    amountPaid: props.data ? props.data.amountPaid : "",
    balanceDue: props.data ? props.data.balanceDue : "",
    currency: props.data ? props.data.currency : "KES",
    status: props.data ? props.data.status : "Unpaid",
    contactEmail: props.data ? props.data.contactEmail : "",
    contactPhone: props.data ? props.data.contactPhone : "",
    remarks: props.data ? props.data.remarks : "",
    companyId: props.data ? props.data.companyId : companyId,
  };

  // 🟢 Fetch client types (Individual / Corporate)
  useEffect(() => {
    async function fetchClientTypes() {
      try {
        const response = await graphqlQuery(allClientTypes, client_url);
        if (response?.data?.allClientTypes) {
         setClientTypes(response.data.allClientTypes);
        }

      } catch (error) {
        console.error("Error fetching client types:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchClientTypes();
  }, []);

  // 🟢 Fetch clients dynamically based on type
  const handleClientTypeChange = async (selectedTypeId) => {
    try {
      setLoading(true);
      let data = [];

      // You may need to adjust the condition depending on what allClientTypes returns
      const selectedType = clientTypes.find(
        (type) => type.id === selectedTypeId
      );

      if (selectedType?.typeName === "Individual Clients") {
        data = await graphqlQuery(allIndividualClients, client_url);
      } else if (selectedType?.typeName === "Corporate Clients") {
        data = await graphqlQuery(allCorporateClients, client_url);
      }

      setClients(
        data.map((c) => ({
          value: c.id,
          label: c.fullName || c.companyName || c.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching clients:", error);
    } finally {
      setLoading(false);
    }
  };

  const fields = getDebtorsFields(clientTypes, clients, handleClientTypeChange);

  
  // 🟢 Handle Form Submission
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            ...values,
            companyId,
          }
        : {
            ...values,
            companyId,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateDebtor" : "createDebtor",
        mutationData,
        props.isEditing ? "updatedDebtor" : "newDebtor",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Debtor ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while saving the debtor record. Please try again.",
      });
    }

    setSubmitting(false);
  };

  if (loading) return <CircularProgress />;

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Debtor" : "Add New Debtor"}
      subtitle={
        props.isEditing
          ? "Update an existing debtor record"
          : "Record a new debtor entry"
      }
    />
  );
};

export default DebtorsForm;
